











import { Vue, Component, Prop } from "vue-property-decorator";
import { IProduct } from "@/models/products";

@Component({
  components: {
    "edit-product-attributes": () =>
      import(
        "@/components/app/admin/catalogue/products/attributes/editProductAttributes.vue"
      )
  }
})
export default class ProductAttachedAttributesView extends Vue {
  @Prop({ required: true })
  public productId!: IProduct["id"];
}
